import { Modal, ModalBackButton } from '@/components/Modal'
import styles from './Modal.module.scss'
import React, { memo, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import cl from 'classnames'
import { Field as FormikField, Form, Formik } from 'formik'
import { sickLeaveThunks } from '@/entity'
import { useDispatch, useSelector } from 'react-redux'
import { getCurrentLanguage } from '@/i18next'
import { Button, Checkbox, Field } from '@/ui'
import { LoadingBlocker, LoadingScreen } from '@/components/Loader'
import { message } from 'antd'

const FORM_NAME = {
	employers: 'employers',
	isApprove: 'isApprove',
	confirmCode: 'confirmCode',
	listId: 'listId',
}
const formInitialState = {
	[FORM_NAME.employers]: [],
	[FORM_NAME.isApprove]: false,
	[FORM_NAME.confirmCode]: '',
	[FORM_NAME.listId]: null,
}

export const SendModal = memo(({ onClose, item, onBack, queryParams }) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const lang = getCurrentLanguage()

	const { user, actualContract, setSickLeave } = useSelector((state) => ({
		user: state?.user?.user,
		actualContract: state?.sickLeave?.actualContract,
		setSickLeave: state?.sickLeave?.setSickLeave,
	}))

	useEffect(() => {
		if (user) {
			let body = {
				iin: user?.iin,
			}

			if (!actualContract.data?.length) {
				dispatch(sickLeaveThunks.getActualContract(body))
			}
		}
	}, [])

	const handleFormSubmit = (data) => {
		const employers = data.employers?.map((employer) => {
			let result = actualContract?.data?.find((contract) => contract.key === employer)

			let currentLang = {
				rus: result?.companyName,
				kz: result?.companyNameKaz,
			}

			return {
				bin: result?.bin,
				orgName: currentLang[lang],
			}
		})

		const body = {
			data: {
				...data,
				employers,
				[FORM_NAME.confirmCode]: '',
				[FORM_NAME.listId]: item.listId,
			},
			onSuccess: () => {
				const refreshBody = {
					type: 'employee',
					params: {
						page: queryParams?.page,
						size: queryParams?.pageSize,
					},
				}

				dispatch(sickLeaveThunks.getSickData(refreshBody))
				onClose()
				message.success(t('success_alert'))
			},
		}

		dispatch(sickLeaveThunks.setSickLeave(body))
	}

	const actualContractArray =
		actualContract?.data?.map((contract) => ({
			code: contract.key,
			kz: `${contract.companyNameKaz}, ${contract.establishedPost}`,
			rus: `${contract.companyName}, ${contract.establishedPost}`,
		})) || []

	return (
		<>
			<Modal windowClassName={cl(styles.modal_wrapper, styles.modal_wrapper__send)}>
				<ModalBackButton onClick={onBack} />
				<div className={`${styles.wrapper} scroll`}>
					<div className={styles.header}>
						<h1 className={cl(styles.title, styles.titlebig)}>{t('sickLeave.send_employer')}</h1>
					</div>

					<div className={cl(styles.header, 'mt-4')}>
						<span className={cl(styles.title, styles.titlesmall)}>
							{t('sickLeave.number', { number: item.total?.number ? `№${item.total?.number}` : '' })}
						</span>
						<span className={styles.subtitle}>
							{item.total?.sinceReleasWrk} - {item.total?.tillReleasWrk}
						</span>
					</div>

					{actualContract.loading ? (
						<LoadingScreen />
					) : (
						<div className={cl(styles.body, 'mt-4')}>
							<Formik initialValues={formInitialState} onSubmit={handleFormSubmit}>
								{({ values }) => {
									return (
										<Form>
											<FormikField name={FORM_NAME.employers}>
												{({ field }) => (
													<Field
														fieldType="multipleSelect"
														options={actualContractArray}
														label={t('employer')}
														placeholder={t('sickLeave.choose_employer')}
														{...field}
													/>
												)}
											</FormikField>

											<div className={cl('mt-4')}>
												<FormikField name={FORM_NAME.isApprove}>
													{({ field }) => <Checkbox {...field} label={t('sickLeave.approve_personal_data')} />}
												</FormikField>
											</div>

											<div className={cl(styles.footer, 'mt-4')}>
												<Button type="bare" onClick={onBack}>
													{t('cancel')}
												</Button>

												<Button type="submit" disabled={!(values.isApprove && values.employers?.length > 0)}>
													{t('send')}
												</Button>
											</div>
										</Form>
									)
								}}
							</Formik>
						</div>
					)}
				</div>
			</Modal>

			{setSickLeave.loading && <LoadingBlocker />}
		</>
	)
})
